import { AdminSpecialityList } from './components/pages/admin/speciality/speciality-list';
import { Layout } from './components/general/layout';
import Home from './components/home';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { AdminModalityList } from './components/pages/admin/modality/modality-list';
import { AdminClubList } from './components/pages/admin/club/club-list';
import { AdminSeasonList } from './components/pages/admin/season/season-list';
import { AdminCategoryList } from './components/pages/admin/category/category-list';
import { AdminTeamList } from './components/pages/admin/team/team-list';
import { AdminUserList } from './components/pages/admin/user/user-list';
import { ManagementAthleteList } from './components/pages/management/athletes/athlete-list';
import { ManagementTeamList } from './components/pages/management/team/team-list';
import { ManagementStaffList } from './components/pages/management/staff/staff-list';
import { AdminStaffList } from './components/pages/admin/staff/staff-list';
import { CoachAthleteList } from './components/pages/coach/athletes/athlete-list';
import { AdminVideoList } from './components/pages/admin/video/video-list';
import { CoachTrainingTplList } from './components/pages/coach/training-tpl/training-tpl-list';
import { CoachTrainingSessionTplPhases } from './components/pages/coach/training-tpl/training-tpl-phases';
import { CoachTrainingList } from './components/pages/coach/training/training-list';
import { CoachTrainingSessionPhases } from './components/pages/coach/training/training-phases';
import { AthleteTrainingSessionView } from './components/pages/athlete/training/training-view';
import { AthleteVideoList } from './components/pages/athlete/videos/video-list';
import { AdminCompetitionList } from './components/pages/admin/competition/competition-list';
import { CompetitionView } from './components/pages/common/competition-view';
import React, { createContext, useEffect, useState } from 'react';
import { whoami } from './services/user';
import { emptyUser, User } from './interfaces/user';
import Login from './components/user/login';
import Reports from './components/pages/reports';
import { TeamView } from './components/pages/common/team-view';
import { AthleteView } from './components/pages/common/athlete-view';
import { AthletesRanking } from './components/pages/rankings/athletes-ranking';
import { TeamsRanking } from './components/pages/rankings/teams-ranking';
import { AthletesStatistics } from './components/pages/statistics/athletes-statistics';
import { TeamsStatistics } from './components/pages/statistics/teams-statistics';
import WearablesAuthorize from './components/user/wearables-authorize';
import { EventView } from './components/pages/common/event-view';
import { CompetitionsEvents } from './components/pages/common/competitions-events';
import { AdminEventList } from './components/pages/admin/event/event-list';
import { AdminAthleteList } from './components/pages/admin/athletes/athlete-list';
import { AthleteReportsView } from './components/pages/athlete/reports/reports-view';
import { CoachReportsView } from './components/pages/coach/reports/reports-view';
import CoachPlanning from './components/pages/coach/planning/CoachPlanning';
import { CoachTrainingMonitoring } from './components/pages/coach/training/training-monitoring';
import { CoachMonitoringHistory } from './components/pages/coach/monitoring/monitoring-history';
import { AthleteMonitoringHistory } from './components/pages/athlete/monitoring/monitoring-history';
import CoachPlanningReports from './components/pages/coach/planning/CoachPlanningReports';
import CoachPlanningSession from './components/pages/coach/planning/CoachPlanningSession';
import PlanningView from './components/pages/common/planning-view';
import AthletePlanningSession from './components/pages/athlete/planning/AthletePlanningSession';
import { CoachTrainingsList } from './components/pages/coach/trainings/trainings-list';
import { CoachTeamList } from './components/pages/coach/team/team-list';
import { AdminSettings } from './components/pages/admin/settings';
import { KpiSettingsProvider } from './contexts/KpiSettingsContext';
import { VersionUpdateBanner } from './components/general/version-update-banner';
import Documents from './components/pages/documents';

export const UserContext = createContext({userProfile: emptyUser});

function App() {
  const [user, setUser] = useState(emptyUser);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
      whoami()
        .then((whoamiResponse: any) => {
            const userProfile: User = {
                id: whoamiResponse.data.id,
                name: whoamiResponse.data.name,
                email: whoamiResponse.data.user_email,
                first_name: whoamiResponse.data.firstname,
                last_name: whoamiResponse.data.surname,
                birthdate: whoamiResponse.data.birthdate,
                phone: whoamiResponse.data.phone,
                document_id: whoamiResponse.data.document_id,
                description: whoamiResponse.data.description,
                slug: whoamiResponse.data.slug,
                role: whoamiResponse.data.role,
                avatar: whoamiResponse.data.avatar,
                club: whoamiResponse.data.club,
                teams: whoamiResponse.data.teams,
                reference_id: whoamiResponse.data.reference_id,
                status: whoamiResponse.data.status,
                garmin_last_refresh: whoamiResponse.data.garmin_last_refresh,
                garmin_access_token: whoamiResponse.data.garmin_access_token,
                garmin_refresh_token: whoamiResponse.data.garmin_refresh_token,
                garmin_expires_in: whoamiResponse.data.garmin_expires_in,
                garmin_scope: whoamiResponse.data.garmin_scope,
                garmin_jti: whoamiResponse.data.garmin_jti,
                garmin_refresh_token_expires_in: whoamiResponse.data.garmin_refresh_token_expires_in,
                garmin_user_id: whoamiResponse.data.garmin_user_id,
                created: whoamiResponse.data.created,
                changed: whoamiResponse.data.changed,
            }
            if (userProfile.status == 0) {
                localStorage.removeItem('token');
            } else {
              setUser(userProfile);
              setLoaded(true);
            }
        })
        .catch(whoamiError => {
            console.log(whoamiError);
            setLoaded(true);
        });
  }, []);

  const handleLoginSuccess = (user: User) => {
    setUser(user);
  }

  return (
    <Router>
      <div className="App">
          <VersionUpdateBanner />
          <UserContext.Provider value={ {userProfile: user} }>
              { loaded && user.id == 0 &&
                <Login onLoginSuccess={ handleLoginSuccess } />
              }
              { loaded && user.id != 0 &&
              <KpiSettingsProvider>
                <Routes>
                  <Route path="/" index element={<Home />} />

                  <Route path="/" element={<Layout />}>
                  {/* Admin routes */}
                  <Route path="/admin/speciality" element={<AdminSpecialityList />} />
                  <Route path="/admin/modality" element={<AdminModalityList />} />
                  <Route path="/admin/clubs" element={<AdminClubList />} />
                  <Route path="/admin/seasons" element={<AdminSeasonList />} />
                  <Route path="/admin/categories" element={<AdminCategoryList />} />
                  <Route path="/admin/teams" element={<AdminTeamList />} />
                  <Route path="/admin/athletes" element={<AdminAthleteList />} />
                  <Route path="/admin/competitions" element={<AdminCompetitionList />} />
                  <Route path="/admin/events" element={<AdminEventList />} />
                  <Route path="/admin/users" element={<AdminUserList />} />
                  <Route path="/admin/videos" element={<AdminVideoList />} />
                  <Route path="/admin/settings" element={<AdminSettings />} />
                  <Route path="/admin/staff" element={<AdminStaffList />} />

                  {/* Manager routes */}
                  <Route path="/manager/athletes" element={<ManagementAthleteList />} />
                  {/*<Route path="/manager/clubs" element={<Home />} />*/}
                  <Route path="/manager/teams" element={<ManagementTeamList />} />
                  <Route path="/manager/staff" element={<ManagementStaffList />} />
                  <Route path="/manager/videos" element={<AdminVideoList />} />
                  <Route path="/reports" element={<Reports />} />

                  {/* Coach routes */}
                  <Route path="/coach/teams" element={<CoachTeamList />} />
                  <Route path="/coach/athletes" element={<CoachAthleteList />} />
                  <Route path="/coach/training-session-tpls" element={<CoachTrainingTplList />} />
                  <Route path="/coach/training-session-tpls/:id/phases" element={<CoachTrainingSessionTplPhases />} />
                  <Route path="/coach/training-sessions" element={<CoachTrainingList />} />
                  <Route path="/coach/training-sessions/:id/phases" element={<CoachTrainingSessionPhases />} />
                  <Route path="/coach/trainings" element={<CoachTrainingsList />} />
                  <Route path="/coach/videos" element={<AdminVideoList />} />
                  <Route path="/coach/reports" element={<CoachReportsView />} />
                  <Route path="/coach/planning" element={<CoachPlanning />} />
                  <Route path="/coach/planning/view" element={<PlanningView />} />
                  <Route path="/coach/planning/reports" element={<CoachPlanningReports />} />
                  <Route path="/coach/planning/session/:season/:team/:day/:moment/:session" element={<CoachPlanningSession />} />
                  <Route path="/coach/training/monitoring/:team/:day/:day_moment/:day_moment_session" element={<CoachTrainingMonitoring />} />
                  <Route path="/coach/monitoring-history" element={<CoachMonitoringHistory />} />

                  {/* Athlete routes */}
                  <Route path="/athlete/training-sessions/:id/view" element={<AthleteTrainingSessionView />} />
                  {/*<Route path="/athlete/clubs" element={<Home />} />
                  <Route path="/athlete/teams" element={<Home />} />
                  <Route path="/athlete/athletes" element={<Home />} />
                  <Route path="/athlete/training-tpls" element={<Home />} />
                  <Route path="/athlete/training-session" element={<Home />} />*/}
                  <Route path="/athlete/videos" element={<AthleteVideoList />} />
                  <Route path="/reports/athlete/:id/view" element={<AthleteReportsView />} />
                  <Route path="/wearables/authorize" element={<WearablesAuthorize />} />
                  <Route path="/athlete/monitoring-history" element={<AthleteMonitoringHistory />} />
                  <Route path="/athlete/planning/view" element={<PlanningView />} />
                  <Route path="/athlete/planning/session/:season/:team/:day/:moment/:session" element={<AthletePlanningSession />} />

                  {/* Common routes */}
                  <Route path="/documents" element={<Documents />} />
                  <Route path="/competitions-events" element={<CompetitionsEvents />} />
                  <Route path="/competitions/:id/view" element={<CompetitionView />} />
                  <Route path="/events/:id/view" element={<EventView />} />
                  <Route path="/teams/:id/view" element={<TeamView />} />
                  <Route path="/athletes/:id/view" element={<AthleteView />} />
                  <Route path="/training-session/:id/view" element={<AthleteView />} />

                  {/* Rankings */}
                  <Route path="/rankings/athletes" element={<AthletesRanking />} />
                  <Route path="/rankings/teams" element={<TeamsRanking />} />

                  {/* Statistics */}
                  <Route path="/statistics/athletes" element={<AthletesStatistics />} />
                  <Route path="/statistics/teams" element={<TeamsStatistics />} />
                </Route>
              </Routes>
              </KpiSettingsProvider>
            }
          </UserContext.Provider>
      </div>
    </Router>
  );
}

export default App;
